import { type v2 } from '@deque/billing-service-client';
import { type Subscription } from '@deque/billing-utils';

export const isUserSubscription = (
  subscription: Subscription
): subscription is v2.UserSubscription =>
  !('enterprise_id' in subscription && 'license_count' in subscription);
